import { render } from "./SignupView.vue?vue&type=template&id=3537eac9"
import script from "./SignupView.vue?vue&type=script&lang=js"
export * from "./SignupView.vue?vue&type=script&lang=js"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__